/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0 || i === 0 && !(v === 0))
    return 1;
if (i === 2 && v === 0)
    return 2;
return 5;
}

export default ["he",[["AM","PM"]],[["××¤× ××´×¦","××××´×¦"],["AM","PM"]],[["××³","××³","××³","××³","××³","××³","×©×³"],["××× ××³","××× ××³","××× ××³","××× ××³","××× ××³","××× ××³","×©××ª"],["××× ×¨××©××","××× ×©× ×","××× ×©×××©×","××× ×¨×××¢×","××× ××××©×","××× ×©××©×","××× ×©××ª"],["××³","××³","××³","××³","××³","××³","×©×³"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["×× ××³","×¤××¨×³","××¨×¥","××¤×¨×³","×××","××× ×","××××","××××³","×¡×¤××³","×××§×³","× ×××³","××¦××³"],["×× ×××¨","×¤××¨×××¨","××¨×¥","××¤×¨××","×××","××× ×","××××","×××××¡×","×¡×¤××××¨","×××§××××¨","× ×××××¨","××¦×××¨"]],u,[["××¤× ×","×××¨××"],["××¤× ××´×¡","××¡×¤××¨×"],["××¤× × ××¡×¤××¨×","××¡×¤××¨×"]],0,[5,6],["d.M.y","d ×MMM y","d ×MMMM y","EEEE, d ×MMMM y"],["H:mm","H:mm:ss","H:mm:ss z","H:mm:ss zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","â+","â-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","â#,##0.00Â âÂ¤;â-#,##0.00Â âÂ¤","#E0"],"ILS","âª","×©×§× ×××©",{"BYN":[u,"Ñ"],"CNY":["âCNÂ¥â","Â¥"],"ILP":["××´×"],"PHP":[u,"â±"],"THB":["à¸¿"],"TWD":["NT$"]},"rtl", plural];
